module.exports = __webpack_public_path__ + "static/the-secrets-in-the-hot-sauce-12b3515450152ef09e1c6b42076d76c5.jpg";